import React, { FunctionComponent } from "react";
import * as Router from "next/router";
import styled from "styled-components";

import { colours } from "@/utils";

type StyleProps = {
  selected?: boolean;
  activeColour?: string;
  inactiveColour?: string;
};

type SupportSubNavProps = {
  activeSection: string;
  navHandler: (string) => void;
  navItems: {
    href: string;
    text: string;
  }[];
  pageBase: string;
  activeColour?: string;
  inactiveColour?: string;
};

const SupportSubNav: FunctionComponent<SupportSubNavProps> = (props) => {
  const router = Router.useRouter();

  const handleChange = (slug) => {
    props.navHandler(slug);
    router.push(`/${props.pageBase}/${slug}`, undefined, { shallow: true });
  };

  return (
    <S.Container>
      <S.NavBar>
        {props.navItems.map((item) => (
          <S.NavItem
            key={item.href}
            name={item.text}
            onClick={() => handleChange(item.href)}
            selected={props.activeSection === item.href}
            {...props}
          >
            {item.text}
          </S.NavItem>
        ))}
      </S.NavBar>
      <S.LineBreak />
    </S.Container>
  );
};

const S = () => {};

S.Container = styled.div`
  margin-top: 5rem;
`;

S.NavItem = styled.button<StyleProps>`
  display: inline-block;
  background: ${(p) =>
    p.selected
      ? p.activeColour || colours.shell
      : p.inactiveColour || colours.shell};
  padding: 1rem 1rem 1.563rem 1rem;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  white-space: nowrap;
  cursor: pointer;
  color: inherit;
  border: none;
  font: inherit;

  ${(p) =>
    p.selected &&
    `
    font-weight: 700;
  `}

  &:hover {
    background-color: ${colours.shellOverlay};
  }

  &::before {
    display: block;
    content: ${(p) => `'${p.name}'`};
    font-weight: 700;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

S.NavBar = styled.nav`
  margin-top: 5rem;
  overflow-y: hidden;
  display: flex;
`;

S.LineBreak = styled.span`
  display: block;
  height: 1px;
  width: 100%;
  background-color: ${colours.charcoal};
`;

export default SupportSubNav;
